import DEFAULT_ICONS from "./constants";

// eslint-disable-next-line import/prefer-default-export
export var getIcon = function getIcon(severity) {
  return DEFAULT_ICONS[severity] || DEFAULT_ICONS.info;
};